import React from "react";
import { UserOutlined, LogoutOutlined } from "@ant-design/icons";
import { Layout, Dropdown, Avatar, MenuProps } from "antd";
import Images from "../assets/image";
import { useNavigate } from "react-router-dom";

type HeaderProps = {
    userData?: any;
};

const App: React.FC<HeaderProps> = ({ userData }) => {
    const { Header } = Layout;
    const navigate = useNavigate();

    const handleMenuClick = ({ key }: { key: string }) => {
        if (key === '1') {
            window.localStorage.clear();
            navigate('/');
        }
    };

    const menuItems: MenuProps['items'] = [
        {
            key: '1',
            icon: <LogoutOutlined />,
            label: 'Logout',
            danger: true,
        },
    ];

    const menu: MenuProps = {
        items: menuItems,
        onClick: handleMenuClick,
    };

    return (
        <Layout className="sticky top-0 z-10">
            <Header className="user-profile-btn flex items-center p-0 h-[75px]" style={{ backgroundColor: '#1a1a2e' }}>
                {/* Logo */}
                <div className="trip-logo">
                    <div className="p-2 h-[73px]">
                        <img src={Images.triplogo} alt="header logo" className="h-full w-full object-contain" />
                    </div>
                </div>

                {/* Right section */}
                <div className="flex justify-end items-center w-full px-4">
                    <Dropdown menu={menu} placement="bottomRight" trigger={["click"]}>
                        <div className="flex items-center gap-3 cursor-pointer hover:bg-white/10 px-3 py-2 rounded-lg transition-colors">
                            <Avatar
                                size={36}
                                src={userData?.imageUrl || undefined}
                                icon={<UserOutlined />}
                                className="bg-white/20 text-white shrink-0"
                            />
                            <div className="flex flex-col leading-tight text-left">
                                <span className="text-white text-sm font-semibold leading-tight">
                                    {userData?.fullName || "Admin"}
                                </span>
                                <span className="text-white/50 text-xs leading-tight">
                                    {userData?.email || ""}
                                </span>
                            </div>
                            <svg className="w-3.5 h-3.5 text-white/40 ml-1 shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                            </svg>
                        </div>
                    </Dropdown>
                </div>
            </Header>
        </Layout>
    );
};

export default App;